import others from './others'
import notfound from './notfound'
import ads from './ads'

export default [

    ...notfound,
    ...others,
    ...ads,

]